// extracted by mini-css-extract-plugin
export default {"container":"styles_container__HUZq-","separator":"styles_separator__0ULq+"};